import { clsx } from 'clsx';
import { Typography } from '../typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { tag, tagDisabled, tagIcon, tagSelected, events } from './tag.css';

type TagProps = {
  label?: string;
  className?: string;
  selected?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  startIcon?: IconProp;
  startIconClassName?: string;
  endIcon?: IconProp;
  onClick?: () => void;
  labelClassName?: string;
  endIconClassName?: string;
};

export const Tag = (p: TagProps) => (
  <div
    className={clsx(
      tag,
      p?.disabled && tagDisabled,
      p?.selected && tagSelected,
      p?.disabled && 'cursor-not-allowed',
      p?.readonly && 'pointer-events-none',
      p.className,
    )}
    data-testid={`tag-${p.label}`}
    onClick={() => p?.onClick && p.onClick()}
  >
    {p?.startIcon ? (
      <FontAwesomeIcon
        icon={p.startIcon}
        className={clsx(tagIcon, events, p?.startIconClassName)}
      />
    ) : null}
    {p?.label ? (
      <Typography
        variant="body"
        size="medium"
        as="span"
        className={clsx(events, p?.labelClassName)}
      >
        {p.label}
      </Typography>
    ) : null}
    {p?.endIcon ? (
      <FontAwesomeIcon
        icon={p.endIcon}
        className={clsx(tagIcon, events, p?.endIconClassName)}
      />
    ) : null}
  </div>
);
